import axios from "axios";

export default {
  login(username, password, cb) {
    cb = arguments[arguments.length - 1];
    if (localStorage.token) {
      if (cb) cb(true);
      this.onChange(true);
      return;
    }
    axios
      .post("/api-token-auth/", {
        username: username,
        password: password,
      })
      .then((res) => {
        if (res.data.token) {
          localStorage.setItem("token", res.data.token);
          if (cb) cb(true);
          this.onChange(true);
        } else {
          if (cb) cb(false);
          this.onChange(false);
        }
      });
  },

  getToken() {
    return localStorage.token;
  },

  logout(cb) {
    axios
      .post("/api/v1/auth/login/", {
        token: localStorage.token,
      })
      .then(() => {
        delete localStorage.token;
        if (cb) cb();
        this.onChange(false);
      });
  },

  async loggedIn() {
      return localStorage.getItem("token") != null;
    // if (localStorage.getItem("token") === null) {
    //   return false;
    // } else {
    //   try {
    //     let res = await axios.post("/api/v1/auth/verify/", {
    //       token: localStorage.token,
    //     });
    //     if (res.data.token === null) {
    //       return false;
    //     } else {
    //       localStorage.setItem("token", res.data.token);
    //       return true;
    //     }
    //   } catch (error) {
    //     delete localStorage.token;
    //     return false;
    //   }
    // }
  },

  onChange() {},
};
